import { Environment as DeviceIntelligenceEnvironment } from '@1debit/device-intelligence';

import { type Environment } from './environments';

export const getDeviceIntelligenceEnvironment = (env: Environment) => {
	if (env === 'development') return DeviceIntelligenceEnvironment.Development;
	if (env === 'production') return DeviceIntelligenceEnvironment.Production;
	return DeviceIntelligenceEnvironment.NonProduction;
};
